class TabWithMultipleItems {
  preview = false;
  tabPanels = null;
  tabNavigation = null;
  tabButtons = null;
  activeTabButton = null;
  tabContainer = null;
  activeTab = null;
  activeTabClass = "tab-navigation__active";

  constructor(preview) {
    this.preview = preview;
  }

  init() {
    this.tabContainer = document.querySelector(".Tab__Container");
    this.tabPanels = [...this.tabContainer.children];
    this.tabNavigation = document.querySelector(
      ".Tab__Navigation__Container .tab_navigation--button_wrapper",
    );
    this.tabButtons = [...this.tabNavigation.querySelectorAll("button")];

    if (this.preview) return;

    // Set the first button as activeTab by default
    if (this.tabButtons.length > 0) {
      this.activeTabButton = this.tabButtons[0];

      // set first button to aria-selected="true"
      // add active class to first button
      // set tabindex for other buttons to -1
      this.tabButtons.forEach((button, index) => {
        if (index === 0) {
          button.classList.add(this.activeTabClass);
          button.setAttribute("aria-selected", "true");
        } else {
          button.setAttribute("tabindex", "-1");
        }
      });
    }

    // Set the first tab as activeTab by default
    if (this.tabPanels.length > 0) {
      // set active tab panel to first tab
      this.activeTab = this.tabPanels[0].id;

      // set all tabpanels tabindex to 0
      this.tabPanels.forEach((panel) => {
        panel.setAttribute("role", "tabpanel");
        panel.setAttribute("tabindex", "0");
      });
    }

    // set each tabs' x-show attribute
    this.tabPanels.forEach((tab) => {
      if (tab.id) {
        tab.setAttribute("x-show", `activeTab === '${tab.id}'`);
      }
    });

    this.tabNavigation.addEventListener("keydown", (e) => {
      switch (e.key) {
        case "ArrowLeft":
          this.moveLeft();
          break;
        case "ArrowRight":
          this.moveRight();
          break;
      }
    });
  }

  // function for moving left with keyboard
  moveLeft() {
    if (!this.activeTabButton.previousElementSibling) {
      console.log(this.tabButtons[this.tabButtons.length - 1].id);
      this.switchTab(
        this.tabButtons[this.tabButtons.length - 1].id,
        this.tabButtons[this.tabButtons.length - 1],
      );
    } else {
      console.log(this.activeTabButton);
      this.switchTab(
        this.activeTabButton.previousElementSibling.id,
        this.activeTabButton.previousElementSibling,
      );
    }
  }

  // function for moving right with keyboard
  moveRight() {
    if (!this.activeTabButton.nextElementSibling) {
      console.log(this.tabButtons[0].id);
      this.switchTab(this.tabButtons[0].id, this.tabButtons[0]);
    } else {
      console.log(this.activeTabButton);
      this.switchTab(
        this.activeTabButton.nextElementSibling.id,
        this.activeTabButton.nextElementSibling,
      );
    }
  }

  // Function to set active tab to id which is passed from click event in twig template
  switchTab(id, target) {
    this.activeTab = id;
    this.activeTabButton = target;

    // reset aria labels
    this.tabButtons.forEach((button, index) => {
      button.setAttribute("aria-selected", "false");
      button.setAttribute("tabindex", "-1");
    });

    // set active button's aria labels
    this.changeActiveButton(this.activeTabButton);
    this.activeTabButton.setAttribute("aria-selected", "true");
    this.activeTabButton.removeAttribute("tabindex", "-1");
    this.activeTabButton.focus();
  }

  // Function to update active button style
  changeActiveButton(element) {
    this.tabButtons.forEach((button) => {
      button.classList.remove(this.activeTabClass);
    });
    element.classList.add(this.activeTabClass);
  }
}

document.addEventListener("alpine:init", () => {
  Alpine.data(
    "tabWithMultipleItems",
    (preview) => new TabWithMultipleItems(preview),
  );
});
